import React from "react";
import Icon from "./Icon";

export default function Modal({ title, onClose, children, width = 560 }) {
  return (
    <div className="modal-overlay">
      <div className="modal-dialog" style={{ width }}>
        <div className="modal-header">
          <h3 className="modal-title">{title}</h3>
          <button onClick={onClose} className="modal-close-btn">
            <Icon name="x" size={18} color="#6B7280" />
          </button>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
}
